import Vue from 'vue'

// 整体引入
import ElementUI from 'element-ui'
Vue.use(ElementUI)

// 按需全局引入使用
// import { Button } from 'element-ui'
// Vue.use(Button)
